import { getCountryConfig } from '../services/countryConfigService'

export interface PhoneInputConfig {
  minLength: number
  maxLength: number
  startsWith?: string
  placeholder: string
}

const PHONE_INPUT_CONFIGS: Record<string, PhoneInputConfig> = {
  SA: { minLength: 9, maxLength: 9, startsWith: '5', placeholder: '5XXXXXXXX' },
  EG: { minLength: 11, maxLength: 11, startsWith: '01', placeholder: '01XXXXXXXXX' },
}

const DEFAULT_PHONE_INPUT_CONFIG: PhoneInputConfig = {
  minLength: 7,
  maxLength: 15,
  placeholder: 'XXXXXXXXX',
}

/** Active phone region from Settings; SA when unset (legacy Saudi default). */
export const getActivePhoneRegion = (): string => {
  const { phoneRegion } = getCountryConfig()
  return phoneRegion || 'SA'
}

export const getPhoneInputConfig = (phoneRegion?: string): PhoneInputConfig => {
  const region = (phoneRegion || getActivePhoneRegion()).toUpperCase()
  return PHONE_INPUT_CONFIGS[region] || DEFAULT_PHONE_INPUT_CONFIG
}

export const sanitizePhoneNumber = (value: string, phoneRegion?: string): string =>
  value.replace(/\D/g, '').slice(0, getPhoneInputConfig(phoneRegion).maxLength)

export const isValidPhoneNumber = (value: string, phoneRegion?: string): boolean => {
  const phone = value.replace(/\D/g, '')
  const config = getPhoneInputConfig(phoneRegion)
  if (phone.length < config.minLength || phone.length > config.maxLength) return false
  return !config.startsWith || phone.startsWith(config.startsWith)
}
